<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="'/visits/tables/sales-performance-details'"
      [chartColumn]="'Name'"
      [onRowClick]="onUserRowClick"
    >
    </app-api-table>
  }
</app-tab-layout>
